
import React from 'react';
import { Col, Row, Image } from "react-bootstrap";

import PropTypes from 'prop-types';
import Circle from './Circle';
import './CircleSection.scss';

function getRowContent(content, index, reverse) {
  const flip = (!reverse && index % 2 === 0) || (reverse && index % 2 !== 0);

  return (
    <Row key={index} className="">
      <Col xs={{ order: 1, span: 12 }} lg={{ span: 'auto', order: flip ? 12 : 1 }} className={`d-flex align-items-center justify-content-center flex-column ${flip ? 'right-side' : 'left-side'}`} >
        <Row>
          <Circle position={flip ? "right-circle" : "left-circle"} />
          <Image src={content.image} roundedCircle className={content.imageClass ? content.imageClass : ''} alt="" />
        </Row>
        {content.belowPic && <Row className="mt-auto">
          {content.belowPic}
        </Row>}
      </Col>
      <Col xs={{ order: 12, span: 12 }} lg={{ order: flip ? 1 : 12 }} className={`d-flex align-items-center justify-content-center ${flip ? 'left-side' : 'right-side'}`} >
        {content.textContent}
      </Col>
    </Row>
  )
}

export default function CircleSection(props) {
  return (
    <Row className="circle-section justify-content-center">
      <Col className="content-section">
        {props.data.map((d, index) => getRowContent(d, index, props.reverse))}
      </Col>
    </Row>
  );
};

CircleSection.propTypes = {
  reverse: PropTypes.bool,
  data: PropTypes.array.isRequired
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Circles/CircleSection.js